export default "__VITE_ASSET__nnG8iJT6__"